import { CompanyEntity } from '../common/entity';
import { ProductTransactionSpecifiers } from '../productTransaction';
import { WithCustomFields } from '../custom_field/customField';
import { applyMixins } from '../../util/mixins';
import { StockLocationRole } from '../stock_location_role_assignment/stockLocationRoleAssignment';
import { EntityAuthorization } from '../common/entityAuthorization';
import { Address } from '../common/address';

export enum OrderType {
  inbound = 'inbound',
  outbound = 'outbound',
  disposal = 'disposal',
  move = 'move',
  replenish = 'replenish',
}

export enum OrderStatus {
  open = 'open',

  created = 'created',
  inProgress = 'inProgress',
  complete = 'complete',

  shipped = 'shipped',
  arrived = 'arrived',

  cancelled = 'cancelled',
  failed = 'failed',

  disabled = 'disabled',
  released = 'released',

  pickingComplete = 'pickingComplete',
}

export enum OrderParentType {
  order = 'order',
  task = 'task',
}

export class Order extends CompanyEntity {
  public fromStockLocationId: string | undefined;
  public toStockLocationId: string | undefined;
  public contactId?: string = undefined;
  public assignedTo: string[] = [];
  public type: OrderType = OrderType.inbound;
  public status: OrderStatus = OrderStatus.created;
  public products: Map<string, ProductTransactionSpecifiers> = new Map();
  public parentType?: OrderParentType;
  public parentId?: string;
  public number?: string;
  public address?: Address;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
    this.customFields = WithCustomFields.toCustomFieldsMap(obj);
  }

  static hasPicking(order: Order) {
    return order.type === OrderType.outbound || order.type === OrderType.move;
  }
}

export class OrderAuthorization extends EntityAuthorization<Order> {
  forCreate = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forUpdate = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forDelete = () => StockLocationRole.STOCK_LOCATION_SUPERVISOR;
  forGet = () => StockLocationRole.STOCK_LOCATION_VIEWER;

  forProcess = () => StockLocationRole.STOCK_LOCATION_USER;
}

export interface Order extends WithCustomFields {}
applyMixins(Order, [WithCustomFields]);
